/*
 * @Author: renjie
 * @description：  药省保相关 路由
 */
const route = [
  {
    path: '/hospital/solidMedicine/index',
    name: 'solidMedicineIndex',
    component: () => import(/* webpackPrefetchPlaceHolder */ './index'),
    exact: true,
    auth: true,
    title: '药省保直赔',
  },
  {
    path: '/hospital/solidMedicine/list',
    name: 'solidMedicineList',
    component: () => import(/* webpackPrefetchPlaceHolder */ './list'),
    exact: true,
    auth: true,
    title: '直赔记录',
  },
  {
    path: '/hospital/solidMedicine/shop',
    name: 'solidMedicineShop',
    component: () => import(/* webpackPrefetchPlaceHolder */ './shop'),
    exact: true,
    auth: true,
    title: '便捷用药',
  },
  {
    path: '/hospital/solidMedicine/order/confirm',
    name: 'solidMedicineOrderConfirm',
    component: () => import(/* webpackPrefetchPlaceHolder */ './order/confirm'),
    exact: true,
    auth: true,
    title: '确认订单',
  },
  {
    path: '/hospital/solidMedicine/vendor',
    name: 'solidMedicineOrderVendors',
    component: () => import(/* webpackPrefetchPlaceHolder */ './vendors'),
    needLogin: false,
    exact: false,
    title: '资质证明',
  },
  {
    path: '/hospital/solidMedicine/orderPresCreate/create',
    name: 'orderPresCreate',
    component: () => import(/* webpackPrefetchPlaceHolder */ './prescription/orderPresCreate/index'),
    needLogin: true,
    exact: false,
    title: '处方信息',
  },
  {
    path: '/hospital/solidMedicine/orderPresCreate/patientEdit',
    name: 'patientEdit',
    component: () => import(/* webpackPrefetchPlaceHolder */ './prescription/patientEdit'),
    auth: true,
    exact: true,
    title: '更新用药人',
  },
];
export default route;

